import {
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { t } from "i18next";
import React from "react";
import { useGetServicesQuery } from "../../../api/admin/ServiziApi";
import { blue, green, red } from "@mui/material/colors";

const DocCategoriesTable = ({ datas, handleLensClick, practiceServiceId }) => {
  const { data: servicesList } = useGetServicesQuery({
    currentPage: 1,
    startRow: 0,
    endRow: 10000,
  });
  const currentService = servicesList?.Data?.items?.filter(
    (s) => s.id === practiceServiceId
  );

  const getCheckListStatus = (docCategoryId) => {
    if (currentService)
      for (
        let index = 0;
        index < currentService[0]?.categories.length;
        index++
      ) {
        if (currentService[0]?.categories[index].id === docCategoryId)
          return (
            <Tooltip title={t("Complete")}>
              <DoneRoundedIcon style={{ color: green[500] }} />
            </Tooltip>
          );
      }
    return (
      <Tooltip title={t("Optional")}>
        <RemoveRoundedIcon style={{ color: blue[400] }} />
      </Tooltip>
    );
  };

  const missingDocCategories = () => {
    const missingDocCategoriesArray = [];
    const actualDocCategories = datas?.Data?.map(
      (docCategory) => docCategory.categoryId
    );
    if (currentService) {
      for (
        let index = 0;
        index < currentService[0]?.categories.length;
        index++
      ) {
        const foundMissingCategory = actualDocCategories?.includes(
          currentService[0]?.categories[index].id
        )
          ? undefined
          : currentService[0]?.categories[index];
        if (foundMissingCategory)
          missingDocCategoriesArray.push({
            categoryId: foundMissingCategory.id,
            categoryName: foundMissingCategory.name,
          });
      }
    }
    return missingDocCategoriesArray;
  };

  return (
    <TableContainer
      component={Paper}
      className="overflow-auto "
      style={{ height: "759px" }}
    >
      <Table>
        <TableHead>
          <TableRow style={{ backgroundColor: "#e6e6e6" }}>
            <TableCell>{t("Category")}</TableCell>
            <TableCell>{t("Documents")}</TableCell>
            <TableCell>{t("Status")}</TableCell>
            <TableCell>{t("Actions")}</TableCell>
          </TableRow>
        </TableHead>
        {datas?.Data?.map((documento) => (
          <TableRow className="hover:shadow-md" key={documento.categoryId}>
            <TableCell>{documento.categoryName}</TableCell>
            <TableCell>{documento.docCount}</TableCell>
            <TableCell>{getCheckListStatus(documento.categoryId)}</TableCell>
            <TableCell>
              <IconButton
                className="w-10 h-10"
                onClick={() => handleLensClick(documento.categoryId)}
              >
                <SearchRoundedIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
        {missingDocCategories().map((missingDocCategory) => (
          <TableRow className="hover:shadow-md" key={missingDocCategory.id}>
            <TableCell>{missingDocCategory.categoryName}</TableCell>
            <TableCell>{0}</TableCell>
            <TableCell>
              {
                <Tooltip title={t("Incomplete")}>
                  <CloseRoundedIcon style={{ color: red[500] }} />
                </Tooltip>
              }
            </TableCell>
            <TableCell>
              <IconButton disabled className="w-10 h-10">
                <SearchRoundedIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
        {datas?.Data?.length === 0 && missingDocCategories().length === 0 && (
          <TableRow>
            <TableCell colSpan={4} className="text-center text-gray">
              {t("NoDocs")}
            </TableCell>
          </TableRow>
        )}
      </Table>
    </TableContainer>
  );
};

export default DocCategoriesTable;
